import { render, staticRenderFns } from "./CompanyPhoneLinkModal.vue?vue&type=template&id=4c195fd0&scoped=true"
import script from "./CompanyPhoneLinkModal.vue?vue&type=script&lang=js"
export * from "./CompanyPhoneLinkModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyPhoneLinkModal.vue?vue&type=style&index=0&id=4c195fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c195fd0",
  null
  
)

export default component.exports